// Copyright (c) 2023 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import deleteRecentNarrative from "./deleteRecentNarrative"
import searchRecentNarratives from "./searchRecentNarratives"
import { Action } from "redux"
import { RootState } from "../../../app/store"

export default combineEpics<Action, Action, RootState, unknown>(
  searchRecentNarratives,
  deleteRecentNarrative,
)
